import { Box } from "@jewlr/storybook/core"
import loadjs from "loadjs"
import { useEffect } from "react"
import styled from "styled-components"

import { reloadStamped, stampedJsUrl } from "helpers/external/stamped"

const StampedGallery = styled(Box)`
  display: grid;
`

const StampedGetInspired = () => {
  useEffect(() => {
    let timeout

    if (!loadjs.isDefined("stamped")) {
      loadjs(stampedJsUrl(), "stamped", {
        async: true,
        error: () => console.log("Error loading Stamepd"),
        success: () => (timeout = reloadStamped({ gallery: true })),
      })
    } else {
      timeout = reloadStamped({ gallery: true })
    }

    return () => clearTimeout(timeout)
  }, [])

  return (
    <StampedGallery
      data-feed-type="feed"
      data-height="400"
      data-hover-text=""
      data-widget-type="instagram-feed"
      id="stamped-reviews-widget"
    />
  )
}

export default StampedGetInspired
